import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserGear, faClockRotateLeft, faCheck, faUserTie, faTrophy, faStar, faScrewdriverWrench } from "@fortawesome/free-solid-svg-icons";
import './Card.scss';

const Card = ({
  title,
  description,
  image,
  icon,
  href,
  className = '',
  onClick,
}) => {
  const CardWrapper = href ? 'a' : 'div';
  const cardProps = href
    ? { href, className: `card ${className}` }
    : { className: `card ${className}`, onClick };

  return (
    <CardWrapper {...cardProps}>
      {image && (
        <div className="card__image-wrapper">
          <img src={image} alt={title || 'Card image'} className="card__image" />
        </div>
      )}

      {icon && (
        <div className="card__icon">
          {icon === 'faCheck' && <FontAwesomeIcon icon={faCheck} />}
          {icon === 'faUserGear' && <FontAwesomeIcon icon={faUserGear} />}
          {icon === 'faClockRotateLeft' && <FontAwesomeIcon icon={faClockRotateLeft} />}
          {icon === 'faUserTie' && <FontAwesomeIcon icon={faUserTie} />}
          {icon === 'faTrophy' && <FontAwesomeIcon icon={faTrophy} />}
          {icon === 'faStar' && <FontAwesomeIcon icon={faStar} />}
          {icon === 'faScrewdriverWrench' && <FontAwesomeIcon icon={faScrewdriverWrench} />}
        </div>
      )}
      

      <div className="card__body">
        {title && <h3 className="card__title">{title}</h3>}
        {description && (
          <div className="card__description">
            {typeof description === 'string' ? (
              <p>{description}</p>
            ) : (
              description
            )}
          </div>
        )}
      </div>
    </CardWrapper>
  );
};

Card.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  image: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  href: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default Card;
